import { render } from "./xinOrderDetails.vue?vue&type=template&id=e5154020&scoped=true"
import script from "./xinOrderDetails.vue?vue&type=script&lang=js"
export * from "./xinOrderDetails.vue?vue&type=script&lang=js"

import "./xinOrderDetails.vue?vue&type=style&index=0&id=e5154020&scoped=true&lang=less"
import "./xinOrderDetails.vue?vue&type=style&index=1&id=e5154020&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5154020"]])

export default __exports__